module.exports = __webpack_public_path__ + "media/customizations/reverie/logo-new-fce9100db25b576f921674634e3994fc.png";